import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { BackdoorEulaModalModule } from '@app/modals/backdoor-eula-modal/backdoor-eula-modal.module';
import { BackdoorInfoModalModule } from '@app/modals/backdoor-info-modal/backdoor-info-modal.module';
import { environment } from '@env/environment';
import { IonicModule, NavController } from '@ionic/angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { register } from 'swiper/element/bundle';
import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';
import { CoreModule } from './core/core.module';
import { ApiPrefixInterceptorProvider } from './core/http/api-prefix.interceptor';
import { TodaysShiftApiService } from './core/service/api/todaysShift.api.service';
import { ImageViewerService } from './core/service/image-viewer.service';
import { PasscodeTimeoutService } from './core/service/passcode-timeout.service';
import { WhatsNewService } from './core/service/whats-new.service';
import { PsychologicalSurveyModalModule } from './modals/psychological-survey-modal/psychological-survey-modal.module';
import { ReplyInputModalModule } from './modals/reply-input-modal/reply-input-modal.module';
import { TodaysShiftModalModule } from './modals/todays-shift-modal/todays-shift-modal.module';
import { UserSelectorModalModule } from './modals/user-selector-modal/user-selector-modal.module';
import { WhatsNewModalModule } from './modals/whats-new-modal/whats-new-modal.module';
import { ImageViewerModalModule } from './modules/image-viewer-modal/image-viewer-modal.module';
import { InstantFeedbackButtonModule } from './modules/instant-feedback-button/instant-feedback-button.module';
import { SentryModule } from './sentry/sentry.module';
import { SharedModule } from './shared/shared.module';
// import {
//   modalEnterAnimation,
//   modalLeaveAnimation
// } from './utils/ionic-animations';

register();

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule,
    RouterModule.forRoot(AppRoutes, { useHash: true, enableTracing: false }),
    CoreModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    IonicModule.forRoot({
      mode: 'ios',
      menuIcon: 'chevron-back-outline'
      // modalEnter: modalEnterAnimation,
      // modalLeave: modalLeaveAnimation
    }),
    BackdoorInfoModalModule,
    BackdoorEulaModalModule,
    WhatsNewModalModule,
    PsychologicalSurveyModalModule,
    TodaysShiftModalModule,
    InstantFeedbackButtonModule,
    ImageViewerModalModule,
    UserSelectorModalModule,
    ReplyInputModalModule,
    SentryModule
  ],
  bootstrap: [AppComponent],
  providers: [
    WhatsNewService,
    PasscodeTimeoutService,
    TodaysShiftApiService,
    ImageViewerService,
    NavController,
    provideHttpClient(withInterceptorsFromDi()),
    ApiPrefixInterceptorProvider
  ]
})
export class AppModule {}
